export default __webpack_public_path__ + "static/media/getStart.e7f92a51.jpeg";